import { Contract } from "./contract";
import { PaymentMethodOption } from "./payment-method-option";
import { RenewalDates } from "./renewal-dates";
import { RenewalDiscount } from "./renewal-discount";

export class RenewalData {
    referenceDate : string;
    expirationDate: string; 
    invoiceValue: any;
    finalValue: any;
    discountAplied: Array<RenewalDiscount>;
    renewalDates: RenewalDates;
    paymentOptions: Array<PaymentMethodOption>
    contract: Contract
  
    constructor(renewalData: any) {
      this.referenceDate = renewalData.referenceDate;
      this.expirationDate = new Date(renewalData.expirationDate).toLocaleDateString('pt-br');
      this.invoiceValue = renewalData.invoiceValue;
      this.finalValue = renewalData.finalValue;
      this.discountAplied = renewalData.discountAplied
      this.renewalDates = new RenewalDates(renewalData.renewalDates);
      this.paymentOptions = renewalData.paymentOptions;
      this.contract = renewalData.contract;
    }

  }